import { render, staticRenderFns } from "./SvgIconWhatsapp.vue?vue&type=template&id=ae099086&scoped=true&"
import script from "./SvgIconWhatsapp.vue?vue&type=script&lang=js&"
export * from "./SvgIconWhatsapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae099086",
  null
  
)

export default component.exports